"use client"

import styled from "@emotion/styled"
import { useTransitionUpStyles } from "./useTransitionUpStyles"
import {
  springEasing,
  transitionEase,
  transitionTime,
  transitionUpValue,
} from "./utils"

export const TransitionUp = styled.div<{
  $inView: boolean
  $delay?: number
  $isInline?: boolean
  $easing?: keyof typeof springEasing
}>`
  width: 100%;
  opacity: ${(p) => (p.$inView ? 1 : 0)};
  transition: all ${transitionTime}s
    ${(p) => (p.$easing ? springEasing[p.$easing] : transitionEase)};
  transform: ${(p) =>
    p.$inView ? "translateY(0px)" : `translateY(${transitionUpValue})`};
  ${(p) => p.$delay && `transition-delay: ${p.$delay}s;`}
  ${(p) => p.$isInline && `display: inline;`}
`

export const TransitionUpComponent = ({
  children,
  inView,
  delay,
  easing,
}: {
  // eslint-disable-next-line no-unused-vars
  children: ((transitionStyles: any) => React.ReactNode) | null | undefined
  inView: boolean
  delay?: number
  easing?: keyof typeof springEasing
}) => {
  const transitionStyles = useTransitionUpStyles(
    inView,
    delay,
    undefined,
    easing,
  )
  // ... existing code ...

  return children ? children(transitionStyles) : null
}
